import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Section } from "../components";
import "../styles/index.scss";
import { en } from "../content";
import { images } from "../assets";

function About({ isMobile }) {
  const content = en.about;

  return (
    <Box
      className={`about ${isMobile ? "aboutMobile" : "aboutDesktop"}`}
      top={0}
      position={isMobile ? "relative" : "sticky"}
    >
      <Section>
        <Box>
          <Box className="banner" mb={4}>
            {content.title}
          </Box>
          <Grid container justifyContent="space-between" spacing={4}>
            <Grid item xs={12} md={6}>
              <img
                src={images.about.profile}
                alt="profile"
                style={{ width: "80%" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="body">{content.para1}</Box>
              <Box className="body" mt={4}>
                {content.para2}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Section>
    </Box>
  );
}

export default About;
